<template>
    <div>
        <b-button
            title="Merge"
            variant="default"
            @click="$bvModal.show(mergeModalId)"
        >
            <font-awesome-icon :icon="['fas', 'gears']"></font-awesome-icon>
            Merge
        </b-button>
        <modal
            title="Merge Guests"
            :id="mergeModalId"
            ok-title="Merge"
            @ok="mergeGuests"
        >
            Continue to merge selected guests?
        </modal>
    </div>
</template>

<script>
import modal from '../../generic/modal/modal.vue';
export default {
    components: { modal },
    name: 'ActionCellRenderer',
    methods: {
        async mergeGuests() {
            this.params.mergeGuest &&
                (await this.params.mergeGuest(this.params.data.email));
        },
    },
    computed: {
        mergeModalId() {
            return 'merge-modal' + this.params.data.id;
        },
    },
};
</script>